import { AxiosProgressEvent, AxiosResponse } from 'axios';

import { FileManagementResponse } from '../../../../types/FileManagementResponse';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

export const uploadFile = async (
    file: File,
    companyId: string,
    onUploadProgress: (event: AxiosProgressEvent) => void
): Promise<FileManagementResponse> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await authorizedAxiosInstance.post('/v1/files', formData, {
        params: { companyId },
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress,
    });

    return response.data;
};

interface GroupFileResponse {
    id: string;
    groupId: string;
    companyIds: string[];
    dateCreated: string;
    fileName: string;
}

export const uploadGroupFile = async (
    file: File,
    groupId: string,
    onUploadProgress: (event: AxiosProgressEvent) => void
): Promise<GroupFileResponse> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await authorizedAxiosInstance.post('/v1/group-files', formData, {
        params: { groupId },
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress,
    });

    return response.data;
};

export const downloadGroupFile = (fileId: string): Promise<AxiosResponse<Blob>> => {
    return authorizedAxiosInstance.get(`/v1/group-files/${fileId}/download`, {
        responseType: 'blob',
    });
};
